<template lang="html">
  <div class="tab-bar" v-if="show">
    <!-- <slot></slot> -->
    <div class="tab-bar-item" id="recommend">
      <router-link :to="{ name: 'recommend' }">
        <svg class="icon" aria-hidden="true" v-if="routeName !== 'recommend'">
          <use xlink:href="#icon-faxianhaokeweixuanzhongzhuangtai"></use>
        </svg>
        <svg class="icon" aria-hidden="true" v-if="routeName === 'recommend'">
          <use xlink:href="#icon-faxianhaokexuanzhongzhuangtai"></use>
        </svg>
        <span class="tab-bar-item-link" :class="{ on: routeName === 'recommend' }">发现好课</span>
      </router-link>
    </div>
    <!--<div class="tab-bar-item" id="free">-->
      <!--<router-link :to="{ name: 'free-division' }">-->
        <!--<img v-if="routeName !== 'free-division'" src="../assets/icons/tabBar_free.png" alt="today"/>-->
        <!--<img v-if="routeName === 'free-division'" src="../assets/icons/tabBar_free_on.png" alt="today"/>-->
        <!--<span class="tab-bar-item-link" :class="{ on: routeName === 'free-division' }">免费专区</span>-->
      <!--</router-link>-->
    <!--</div>-->

    <div class="tab-bar-item" id="today">
      <router-link :to="{ name: 'today' }">
        <svg class="icon" aria-hidden="true" v-if="routeName !== 'today'">
          <use xlink:href="#icon-yigoukechengweixuanzhongzhuangtai"></use>
        </svg>
        <svg class="icon" aria-hidden="true" v-if="routeName === 'today'">
          <use xlink:href="#icon-yigoukechengxuanzhongzhuangtai"></use>
        </svg>
        <!-- <img v-if="routeName !== 'today'" src="../assets/icons/tabBar_today.png" alt="today"/>
        <img v-if="routeName === 'today'" src="../assets/icons/tabBar_today_on.png" alt="today"/> -->
        <span class="tab-bar-item-link" :class="{ on: routeName === 'today' }">已购课程</span>
      </router-link>
    </div>

    <div class="tab-bar-item" id="mine">
      <router-link :to="{ name: 'mine-page' }">
        <svg class="icon" aria-hidden="true" v-if="routeName !== 'mine-page'">
          <use xlink:href="#icon-gerenzhongxinweixuanzhongzhuangtai1"></use>
        </svg>
        <svg class="icon" aria-hidden="true" v-if="routeName === 'mine-page'">
          <use xlink:href="#icon-gerenzhongxinxuanzhongzhuangtai1"></use>
        </svg>
        <!-- <img v-if="routeName !== 'mine-page'" src="../assets/icons/tabBar_mine.png" alt="mine"/>
        <img v-if="routeName === 'mine-page'" src="../assets/icons/tabBar_mine_on.png" alt="today"/> -->
        <span class="tab-bar-item-link" :class="{ on: routeName === 'mine-page' }">个人中心</span>
      </router-link>
    </div>

  </div>
</template>

<script>
export default {
  name: "TabBar",

  computed: {
    show() {
      return (
        "today,mine-page,recommend,free-division".indexOf(this.routeName) > -1
      );
    },
    routeName() {
      return this.$route.name;
    },
  },
};
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

$global-width: 750;

.tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  height: rem(98);
  width: 100%;
  background-color: #ffffff;
  // 临时加的阴影以区分内容和 tabbar
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);

  &-item {
    float: left;
    width: 33.3%;
    height: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    svg {
      /*height: rem(50);*/
      width: rem(40);
      margin: rem(6) 0;
      height: rem(40);
    }
    &-link {
      display: block;
      text-align: center;
      color: #666666;
      font-size: rem(20);
      font-weight: bold;
      &.on {
        color: $globalColor;
      }
    }

    &:nth-child(2) {
      svg {
        width: rem(38);
        height: rem(46);
      }
    }
    &:nth-child(3) {
      svg {
        width: rem(36);
        height: rem(40);
      }
    }
  }
}
</style>
